import React from 'react';
import { chapters } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
const boxes = [{
  value: '+140',
  label: 'Páginas'
}, {
  value: '12',
  label: 'Capítulos'
}, {
  value: '100%',
  label: 'Fútbol argentino'
}, {
  value: '∞',
  label: 'Acceso de por vida'
}];
export function ProductShowcase() {
  return <section aria-labelledby="producto-title" className="w-full bg-ink-850" data-id="element-162" data-mp="1p2s00vgau0l">
      <div className="mx-auto max-w-4xl px-5 py-16 text-center md:py-20" data-id="element-163" data-mp="3089lpldwb4cz">
        <SectionLabel data-id="element-164" data-mp="355ry5lr4g1pq">El sistema más completo para padres de futbolistas</SectionLabel>
        <h2 id="producto-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-165" data-mp="3a5e91ojh95vd">
          EL MÉTODO DEL PADRE DEL FUTBOLISTA
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-body" data-id="element-166" data-mp="2hgyvz7jwoxmo">
          Un método digital en PDF que ordena, capítulo por capítulo, todo lo que un padre necesita
          entender del fútbol juvenil argentino para acompañar con criterio y sin improvisar.
        </p>
        <div className="mx-auto mt-12 max-w-2xl rounded-[20px] p-8 text-left shadow-panel md:p-10" style={{
        background: '#155e33'
      }} data-id="element-167" data-mp="1px9rb80s2tcj">
          <span className="inline-block rounded-full bg-black/30 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-brand-gold" data-id="element-168" data-mp="1l4qgujxe0eby">
            ⚽ Método Fútbol Digital
          </span>
          <h3 className="mt-6 font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-169" data-mp="1c7g3mt10ef4e">
            El Método del Padre del Futbolista
          </h3>
          <p className="mt-2 text-sm text-white/75" data-id="element-170" data-mp="126vz9hi70uhy">
            El sistema argentino para acompañar, proteger y potenciar la carrera futbolística de tu
            hijo
          </p>
          <ol className="mt-8 space-y-3" data-id="element-171" data-mp="2wlgevfrnpzuh">
            {chapters.map((chapter, index) => <li key={chapter.number} className="flex items-center gap-4 rounded-xl bg-black/25 px-4 py-3" data-id="element-172" data-mp="2rmvdhd0o5a4g" data-mpi={index}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-gold text-sm font-black text-black" data-id="element-173" data-mp="pvv5jvh4jmb7">
                  {index + 1}
                </span>
                <span className="text-[15px] font-semibold text-white" data-id="element-174" data-mp="g0uzdbygcgb1">{chapter.title}</span>
              </li>)}
          </ol>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-175" data-mp="18o7bes6zl5q3">
          {boxes.map(box => <div key={box.label} className="rounded-xl border border-ink-border bg-ink-card px-4 py-6 shadow-panel" data-id="element-176" data-mp="1dnk4vvsd5b1n">
              <p className="font-display text-3xl font-black text-brand-gold" data-id="element-177" data-mp="zpc0j2szz7gg">{box.value}</p>
              <p className="mt-1 text-sm text-subtle" data-id="element-178" data-mp="13n1h4pxohaeg">{box.label}</p>
            </div>)}
        </div>
      </div>
    </section>;
}